<template>
    <v-row >
        <!--
        <v-col cols="12" class="pb-0">
                <v-container class="pt-0">
                    <div class="text-xl-h4 text-h6 font-weight-regular">General Proposal Information</div>
                </v-container>
        </v-col>
        -->
        <v-col cols="12" md="6" class="pb-0">
                <v-text-field
                label="Prospect"
                readonly
                outlined
                :value="planOpportunityViewmodel.client.client_name"
                hide-details
                >
                </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
                <v-text-field
                label="Plan Type"
                readonly
                outlined
                :value="planTypeSection.displayName"
                hide-details
                >
                </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
                <v-text-field
                label="Broker Dealer"
                readonly
                outlined
                :value="brokerSection.radioSelected.broker_dealer_name"
                hide-details
                >
                </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
                <v-text-field
                label="Advisor"
                readonly
                outlined
                :value="advisorSection.radioSelected.advisor_name"
                hide-details
                >
                </v-text-field>
        </v-col>
        
        <v-container v-for="(vm, index) in proposalViewModels" :key="vm.id" :cols=12>
            <v-row v-if="!planTypeSection.isCBOnly">
                <v-col cols="12" class="pb-0">
                    <v-container class="pt-0">
                        <div class="text-xl-h4 text-h6 font-weight-regular">
                            Proposal #{{index+1}} - {{vm.packet.rk_name}}
                        </div>
                    </v-container>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Wholesaler Name"
                    readonly
                    outlined
                    :value="vm.packet.rep_name"
                    hide-details
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Wholesaler Email"
                    readonly
                    outlined
                    :value="vm.packet.rep_email"
                    hide-details
                    >
                    </v-text-field>
                </v-col>
            </v-row>        
        </v-container>
        <!-- OLD VERSION
        <v-container v-for="(proposal, index) in proposalCalcs" :key="proposal.id" :cols=12>
            <v-row>
                <v-col cols="12" class="pb-0">
                    <v-container class="pt-0">
                        <div class="text-xl-h4 text-h6 font-weight-regular">Proposal #{{index+1}} - {{proposal.rk.rk_name}}</div>
                    </v-container>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Record Keeping Platform"
                    readonly
                    outlined
                    :value=proposal.rk.rk_name
                    hide-details
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                        <v-text-field
                        label="Provider Name"
                        readonly
                        outlined
                        :value=proposal.wholesaler.wholesaler_name
                        hide-details
                        >
                        </v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                        <v-text-field
                        label="Wholesaler Name"
                        readonly
                        outlined
                        :value=proposal.rep_user.rep_name
                        hide-details
                        >
                        </v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                        <v-text-field
                        label="Wholesaler Email"
                        readonly
                        outlined
                        :value=proposal.rep_user.rep_email
                        hide-details
                        >
                        </v-text-field>
                </v-col>
            </v-row>
            
        </v-container>
        -->
    </v-row>
    <!-- OLD VERSION
    <div class="GeneralInfo" v-else>
        <v-row >
            <v-col cols="12" class="pb-0">
                    <v-container class="pt-0">
                        <div class="text-xl-h4 text-h6 font-weight-regular">General Proposal Information</div>
                    </v-container>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Prospect"
                    readonly
                    outlined
                    :value=proposalCalcs.client.client_name
                    >
                    </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Takeover Type"
                    readonly
                    outlined
                    :value=proposalCalcs.takeover_type.takeover_name
                    >
                    </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Advisor"
                    readonly
                    outlined
                    :value=proposalCalcs.advisor.advisor_name
                    >
                    </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Advisor Email"
                    readonly
                    outlined
                    :value=proposalCalcs.advisor.advisor_email
                    >
                    </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Record Keeping Platform"
                    readonly
                    outlined
                    :value=proposalCalcs.rk.rk_name
                    >
                    </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Provider Name"
                    readonly
                    outlined
                    :value=proposalCalcs.wholesaler.wholesaler_name
                    >
                    </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Wholesaler Name"
                    readonly
                    outlined
                    :value=proposalCalcs.rep_user.rep_name
                    >
                    </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
                    <v-text-field
                    label="Wholesaler Email"
                    readonly
                    outlined
                    :value=proposalCalcs.rep_user.rep_email
                    >
                    </v-text-field>
            </v-col>
            
        </v-row>
    </div>
    -->
</template>

<script>
  import { mapGetters} from 'vuex';
  export default {
    
    data: () => ({}),  
      
    props: {},
    
    mounted () {},
    
    beforeDestroy() {},
    
    computed: {
      ...mapGetters({
          planOpportunityViewmodel: 'getplanOpportunityViewmodel',
        //   client: 'readClient',
          pricingSection: 'getPricingSection',
          planTypeSection: 'getPlanTypeSection',
          cashBalanceSection: 'getCashBalanceSection',
          brokerSection: 'getBrokerSection',
          advisorSection: 'getAdvisorSection',
          proposalViewModels: 'getProposalViewModels',

        //   proposalCalcs: 'proposalCalcs'
      }),
    },

    methods: {},

    components: {}
  };
</script>

<style type="text/css" scoped>

</style>

